export default {
  PRIVATE_SESSION_REQUESTS: 'private_session_requests',
  TODAY_EVENTS:             'today_events',
  TRANSACTIONS:             'transactions'
};
